import React, { useState } from "react";
import "./backlogbool.css";
import "./BacklogCount.css"
import { getSelectedSem } from "./calculations";


function Backlogbool() {
  const [hasBacklog, setHasBacklog] = useState(null);
  
    const handleChange = (e) => {
      const value = Number(e.target.value);
      getSelectedSem(value);
      setHasBacklog(value);
      console.log("hasBacklog:", value); // For debugging
       let displayArea = document.getElementById("backlogCount");
  if(value===1){
    console.log("ayan");
    displayArea.style.display="block";
  }else if(value===0){
    displayArea.style.display="none";
  }
    };
  

  return (
    <div>
    <div className="options-grid">
      <label className="radio-button">
        <input
          type="radio"
          name="option"
          value="1"
          onClick={handleChange}
        />
        <div className="radio-circle"></div>
        <span className="radio-label">Yes</span>
      </label>
      <label className="radio-button">
        <input
          type="radio"
          name="option"
          value="0"
          onClick={handleChange}
        />
        <div className="radio-circle"></div>
        <span className="radio-label">No</span>
      </label>
    </div>

    <div className="backlogCount" id="backlogCount" >
        <p>In how many semesters<br></br> you have backlog?</p>
        <div>
<input type="text" autoComplete="off" name="text" class="input" placeholder="Total backlog semesters"></input></div>
        </div>

    </div>
  );
}


export default Backlogbool;

